// //for PROD Tenant Environment
export const environment = {
  production: true,
  tenant: "5b268d57-2a6f-4e04-b0de-6938583d5ebc",
  clientID: 'f12a0f5f-3b1e-49c3-8dfa-dc9c9b5b933b',
  authority: 'https://login.microsoftonline.com/5b268d57-2a6f-4e04-b0de-6938583d5ebc',
  storeAuthStateInCookie: false,
  defaultScope: "api://f12a0f5f-3b1e-49c3-8dfa-dc9c9b5b933b/AccessAsUser",
  redirectUri : "https://mercury.products.abbott",
  apiBaseURL: "/api",
  apiURL: "https://mercury.products.abbott"
};
